import React from "react";
import { connect } from "react-redux";
// import { store, authHeader } from '../../_helpers';
import {
  Modal,
  ModalHeader,
  Button,
  ModalFooter,
  Row,
  ModalBody,
  Container,
  Col,
} from "reactstrap";
import ServerPaginatedTable from "../utils/pagination.server";
import moment from "moment";
import ToolTipItem from "../utils/tooltip";
import PageEmptyContent from "../utils/page.empty-content";
import { appHelpers } from "../../_helpers";
import { modalActions } from "../../_actions";
import ViewIcon from "react-icons/lib/md/remove-red-eye";
import PassengersDetails from "./passenger-table";

const getTSCNaira = () => {
  return "NGN";
};

const DataTable = ({
  data,
  converter,
  downloadFile,
  toggleModal,
  totalCount,
}) => {
  return data.length === 0 ? (
    <PageEmptyContent message="No record match your search!" />
  ) : (
    <div className="view">
      <div className="table-responsive">
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th>
                <span>Airline</span>
              </th>
              <th>
                <span>Bank</span>
              </th>
              <th>
                <span>Total Amount</span>
              </th>
              <th>
                <span>Currency</span>
              </th>
              <th>
                <span>Number of Flight</span>
              </th>
              <th>
                <span>Invoice Number</span>
              </th>
              
              <th>
                <span>Invoice Date</span>
              </th>
              <th>
                <span>Action</span>
              </th>
             
            </tr>
          </thead>
          <tbody>
            {data.map((record, i) => (
              <tr key={i + 1}>
                <td className="text-capitalize">
                  {converter(record.AirlineId)}
                </td>
                <td>{record.Bank}</td>
                <td className="text-capitalize">
                  {appHelpers.numberWithCommas(record.Amount)}
                </td>
                <td>{getTSCNaira()}</td>
                <td className="text-capitalize">{record.ManifestCount}</td>
                <td>{record.InvoiceNumber}</td>
                <td>{moment(record.InvoiceDate).format("MMM Do YYYY")}</td>

                <td>
                  <span
                    className="pointer"
                    onClick={() => toggleModal(record)} // Pass the record to the modal
                  >
                    <ToolTipItem
                      key={"viewRecord"}
                      title={<ViewIcon size="18" color="#3da7e2" />}
                      content="View"
                      id={"viewRecord"}
                    />
                  </span>
                </td>
                {/* <td ><a href={record.StmtOfTscFilePath} download={record.StmtOfTscFilePath}> <ToolTipItem key={'downloadPdfIcon'} title={<PdfIcon size="18" color="#e53335" className="icon-picture-as-pdf"/>} content='Download PDF' id={'downloadPdfIcon'}/></a></td>
                                <td><a href={record.StmtOfTscExcelPath} download={record.StmtOfTscExcelPath}> <ToolTipItem key={'downloadExcelIcon'} title={<ExcelIcon size="18" color="#5ead57" className="icon-insert-drive-file"/>} content='Download Excel' id={'downloadExcelIcon'}/></a></td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

class PaginatedResult extends React.Component {
    constructor(props) {
      super(props);
  
      this.state = {
        openModal: false,
        selectedRecord: null, // Initialize selectedRecord to null
        aggregatorId: null, // If required for your logic
      };
    }
  
    toggleModal = (record) => {
      this.setState((prevState) => ({
        openModal: !prevState.openModal,
        selectedRecord: record || null, // Set the selected record or null when closing
      }));
    };
  
    render() {
      const {
        converter,
        pageSize,
        currentPage,
        totalCount,
        navigate,
        recordResults,
        downloadFile,
      } = this.props;
  
      const { selectedRecord, openModal } = this.state;
  
      return (
        <div>
          <div className="row">
            <div className="col-md-12 col-sm-12 mb-4">
              <ServerPaginatedTable
                currentPage={currentPage}
                fetchMore={navigate}
                target={
                  <DataTable
                    totalCount={totalCount}
                    toggleModal={this.toggleModal}
                    data={recordResults}
                    downloadFile={downloadFile}
                    converter={converter}
                  />
                }
                pageSize={pageSize}
                totalCount={totalCount}
              />
            </div>
          </div>
          <Modal
            size="lg"
            isOpen={openModal}
            toggle={() => this.toggleModal(null)} // Close the modal
          >
            <ModalHeader toggle={() => this.toggleModal(null)}>
              Passenger Details
            </ModalHeader>
            <ModalBody>
              {selectedRecord && selectedRecord.NewPassengersDetails ? (
                <PassengersDetails
                  records={{ NewPassengersDetails: selectedRecord.NewPassengersDetails }}
                />
              ) : (
                <p>No passenger details available for this record.</p>
              )}
            </ModalBody>
          </Modal>
        </div>
      );
    }
  }
  

function mapStateToProps(state, ownProps) {
  return {
    modal: state.modal,
  };
}

export default connect(mapStateToProps)(PaginatedResult);



// WEBPACK FOOTER //
// ./src/views/unbillled-passengers/record.js